import Table from '@/common/components/Table'
import TextField from '@/common/components/TextField'
import { DatePickerWithRange } from '@/common/components/ui/dateRangePicker'
import useDebounce from '@/common/hooks/useDebounce'
import { useFilterDate } from '@/common/hooks/useFilterDate';
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { userConsumptionHistoryColumns } from '@/features/privateCompanies/constants/userConsumptionHistoryColumns.constant'
import { useUserEvents } from '@/features/privateCompanies/hooks/useUserEvents'
import { UserEventData, UserEventTableItem } from '@/features/privateCompanies/types/userEvents.type'
import { UserEventsTransformer } from '@/features/privateCompanies/utils/userEventsTransformer'
import { SearchIcon } from 'lucide-react'
import { useParams } from 'react-router-dom'

export const ConsumptionHistory = () => {
  const { id: userId } = useParams()

  const { filterParams, setFilterParams } = useFilterParams();
  const { date, formattedDate } = useFilterDate(filterParams);

  const [search, setSearch] = useDebounce(filterParams.consumptionHistorySearch || '');

  const {
    data: userEvents,
    meta,
    isFetching: userEventsIsFetching,
  } = useUserEvents({
    filters: {
      userId,
      search,
      startDate: formattedDate.from,
      endDate: formattedDate.to,
    },
    mapper: Mapper.mapWithTransformer<UserEventData[], UserEventTableItem[]>({
      transformer: UserEventsTransformer.tableTransformer(),
    }),
  })

  return (
    <div className="flex flex-col gap-6">
      <TextField
        LeftIcon={<SearchIcon />}
        placeholder="Pesquisar"
        className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
        value={filterParams.consumptionHistorySearch || ''}
        onChange={(e: any) => {
          setSearch(e.target?.value)
          setFilterParams((prev) => ({
            ...prev,
            consumptionHistorySearch: e.target?.value,
          }))
        }}
      />

      <div className="flex">
        <DatePickerWithRange date={date} setDate={(date) => setFilterParams((params) => ({ ...params, date }))} />
      </div>

      <Table
        className="max-h-[calc(100vh-324px)]"
        columns={userConsumptionHistoryColumns}
        isLoadingData={userEventsIsFetching}
        rows={userEvents}
        rowEmptyValue="--"
        page={filterParams.page || 1}
        setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
        totalPages={meta.total_pages}
        totalCount={meta.total}
      />
    </div>
  )
}
